var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProLevelFour(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 224,
    viewBox: "0 0 224 224",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_347_7367",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 224,
    height: 224
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 112,
    cy: 112,
    r: 112,
    fill: "#EAFDDC"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_347_7367)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 112,
    cy: 112,
    r: 112,
    fill: "#FDECE9"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_347_7367)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44 71.8621L112 56L180 71.8621V208.276L112 240L44 208.276V71.8621Z",
    fill: "url(#paint0_linear_347_7367)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M48.1163 205.654V75.1287L112 60.2268L175.884 75.1287V205.654L112 235.458L48.1163 205.654Z",
    stroke: "url(#paint1_linear_347_7367)",
    strokeWidth: 8.23253
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1761 207.527V72.7954L112 57.2076L178.824 72.7954V207.527L112 238.702L45.1761 207.527Z",
    stroke: "url(#paint2_linear_347_7367)",
    strokeOpacity: 0.2,
    strokeWidth: 2.35215
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.266 204.049V208.275H100.139V189.241H104.856V204.049H117.269H117.266Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.636 189.241V194.504H111.904V189.241H107.187V201.703H111.904V198.758H119.636V208.275H124.323V189.241H119.636Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8468 143.172V133.293H83.9637V141.352H87.8871V143.172H81.8468ZM90.5659 133.293H97.199V135.114H92.6828V137.33H96.3522V139.065H92.6828V141.352H97.3542V143.172H90.5659V133.293ZM104.058 143.257C103.117 143.257 102.294 143.05 101.588 142.636C100.883 142.213 100.332 141.625 99.9371 140.872C99.5513 140.119 99.3585 139.24 99.3585 138.233C99.3585 137.226 99.556 136.346 99.9512 135.594C100.346 134.841 100.911 134.258 101.645 133.844C102.379 133.42 103.249 133.209 104.256 133.209C105.055 133.209 105.761 133.359 106.373 133.66C106.994 133.961 107.492 134.385 107.869 134.93C108.254 135.476 108.49 136.102 108.574 136.807H106.457C106.335 136.262 106.076 135.824 105.681 135.495C105.295 135.166 104.801 135.001 104.199 135.001C103.653 135.001 103.178 135.137 102.774 135.41C102.369 135.683 102.059 136.064 101.842 136.553C101.626 137.043 101.518 137.602 101.518 138.233C101.518 138.863 101.621 139.423 101.828 139.912C102.045 140.401 102.35 140.783 102.746 141.055C103.15 141.328 103.635 141.465 104.199 141.465C104.481 141.465 104.759 141.427 105.032 141.352C105.305 141.276 105.554 141.159 105.78 140.999C106.015 140.839 106.208 140.637 106.358 140.392C106.518 140.138 106.622 139.837 106.669 139.489V139.362H104.213V137.682H108.631V143.172H107.149L106.937 141.987C106.768 142.222 106.547 142.434 106.274 142.622C106.001 142.81 105.681 142.965 105.314 143.088C104.947 143.201 104.528 143.257 104.058 143.257ZM111.877 133.293H118.51V135.114H113.994V137.33H117.663V139.065H113.994V141.352H118.665V143.172H111.877V133.293ZM121.492 143.172V133.293H123.411L127.603 139.517V133.293H129.692V143.172H127.758L123.567 136.949V143.172H121.492ZM132.926 143.172V133.293H136.525C137.56 133.293 138.458 133.5 139.22 133.914C139.983 134.328 140.575 134.907 140.999 135.65C141.431 136.393 141.648 137.25 141.648 138.219C141.648 139.188 141.431 140.044 140.999 140.787C140.575 141.531 139.983 142.114 139.22 142.537C138.458 142.961 137.56 143.172 136.525 143.172H132.926ZM135.043 141.408H136.525C137.155 141.408 137.692 141.272 138.134 140.999C138.576 140.726 138.91 140.35 139.136 139.87C139.362 139.39 139.475 138.84 139.475 138.219C139.475 137.588 139.362 137.038 139.136 136.567C138.91 136.088 138.576 135.716 138.134 135.453C137.692 135.189 137.155 135.057 136.525 135.057H135.043V141.408Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.733 75.8292L101.733 124.209H104.895L104.895 75.8292H101.733ZM101.733 154.346L101.733 182.898H104.895L104.895 154.346H101.733ZM107.268 124.209L107.268 75.8292H110.43L110.43 124.209H107.268ZM107.268 154.346L107.268 182.898H110.43L110.43 154.346H107.268ZM112.802 124.209L112.802 75.8292H115.965L115.965 124.209H112.802ZM112.802 154.346L112.802 182.898H115.965L115.965 154.346H112.802Z",
    fill: "url(#paint3_linear_347_7367)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.454 124.209L118.454 75.8292H121.617L121.617 124.209H118.454Z",
    fill: "url(#paint4_linear_347_7367)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.454 154.346L118.454 182.898H121.617L121.617 154.346H118.454Z",
    fill: "url(#paint5_linear_347_7367)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_347_7367",
    x: 44,
    y: 44.2392,
    width: 136,
    height: 195.761,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -11.7608
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.82057
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.192157 0 0 0 0 0.0431373 0 0 0 0 0.0196078 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "shape",
    result: "effect1_innerShadow_347_7367"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_347_7367",
    x1: 112,
    y1: 56,
    x2: 112,
    y2: 240,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED6E5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#310B05"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_347_7367",
    x1: 112,
    y1: 75.8276,
    x2: 112,
    y2: 240,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#310B05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#310B05",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_347_7367",
    x1: 112,
    y1: 153.948,
    x2: 112,
    y2: 240,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_347_7367",
    x1: 108.849,
    y1: 123.812,
    x2: 108.849,
    y2: 182.898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_347_7367",
    x1: 114.501,
    y1: 123.812,
    x2: 114.501,
    y2: 182.898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_347_7367",
    x1: 114.501,
    y1: 123.812,
    x2: 114.501,
    y2: 182.898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProLevelFour);
export default __webpack_public_path__ + "static/media/pro-level-four.816db0531432910680c56c0f5b9e2786.svg";
export { ForwardRef as ReactComponent };